// Add project specific javascript code and import of additional bundles here:
import "sulu-ai-translator-bundle";

// --- CKEditor5: zusätzliche Plugins aktivieren ---
import {configRegistry, pluginRegistry} from 'sulu-admin-bundle/containers/CKEditor5';
import {BlockQuote} from '@ckeditor/ckeditor5-block-quote';
import {HorizontalLine} from '@ckeditor/ckeditor5-horizontal-line';
// FontColor/FontBackgroundColor not needed in CKEditor5 v48+ (built-in in @ckeditor/ckeditor5-font)

pluginRegistry.add(BlockQuote);
pluginRegistry.add(HorizontalLine);

configRegistry.add(function(previousConfig) {
    return Object.assign({}, previousConfig, {
        toolbar: (previousConfig.toolbar || []).concat([
            '|',
            'blockQuote',
            'horizontalLine',
            '|',
            'fontColor',
            'fontBackgroundColor',
        ]),
    });
});

// --- Sulu Validierungsfehler-Overlay für Redakteure ---
// Zeigt klar: welcher Block → welches Feld → was fehlt
(function() {

    // Übersetzungen Feldname → Lesbare Bezeichnung
    var FIELD_LABELS = {
        'title': 'Titel',
        'description': 'Beschreibung',
        'subtitle': 'Untertitel',
        'buttonText': 'Button-Text',
        'buttonUrl': 'Button-URL',
        'image': 'Bild',
        'backgroundImage': 'Hintergrundbild',
        'features': 'Features',
        'items': 'Einträge',
        'reviews': 'Bewertungen',
        'tools': 'Tools',
        'logos': 'Logos',
        'steps': 'Schritte',
        'posts': 'Beiträge',
        'name': 'Name',
        'icon': 'Icon',
        'quote': 'Zitat',
        'authorName': 'Autor Name',
        'authorRole': 'Autor Rolle',
        'authorImage': 'Autor Bild',
        'rating': 'Bewertung',
        'articles': 'Artikel',
        'countdownDate': 'Zieldatum',
        'sectionBadge': 'Abschnitt-Badge',
        'columns': 'Spalten',
        'layout': 'Layout',
        'blocks': 'Inhaltsblöcke',
    };

    // Block-Typ → Lesbarer Name
    var BLOCK_TYPE_LABELS = {
        'hero': 'Hero-Bereich',
        'statistics': 'Statistiken',
        'brand_logos': 'Markenlogos',
        'feature_grid': 'Feature-Grid',
        'feature_cards': 'Feature-Cards',
        'content_section': 'Inhaltsbereich',
        'content_checkboxes': 'Checkboxen',
        'video_section': 'Video-Bereich',
        'testimonials': 'Kundenstimmen',
        'process_steps': 'Prozessschritte',
        'integrations_grid': 'Integrations-Grid',
        'blog_posts': 'Blog-Beiträge',
        'blog_posts_dynamic': 'Blog-Beiträge (dynamisch)',
        'cta_banner': 'CTA-Banner',
        'deadline_countdown': 'Countdown',
        'team_grid': 'Team-Grid',
        'pricing_table': 'Preistabelle',
        'faq_accordion': 'FAQ',
        'contact_form': 'Kontaktformular',
        'newsletter': 'Newsletter',
        'rating_boxes': 'Bewertungsboxen',
        'comparison_table': 'Vergleichstabelle',
        'inner_page_hero': 'Seiten-Hero',
    };

    // Fehlertyp → Lesbare Meldung
    var ERROR_MESSAGES = {
        'required': 'Pflichtfeld ist leer',
        'minLength': 'Text ist zu kurz',
        'maxLength': 'Text ist zu lang',
        'minimum': 'Wert ist zu klein',
        'maximum': 'Wert ist zu groß',
        'pattern': 'Ungültiges Format',
        'format': 'Ungültiges Format',
        'type': 'Falscher Datentyp',
    };

    function getLabel(key) {
        return FIELD_LABELS[key] || key;
    }

    function getBlockLabel(type) {
        return BLOCK_TYPE_LABELS[type] || type;
    }

    function getErrorMessage(errorObj) {
        if (!errorObj || typeof errorObj !== 'object') {
            return errorObj === true ? 'Pflichtfeld ist leer' : String(errorObj);
        }
        var keyword = errorObj.keyword || '';
        return ERROR_MESSAGES[keyword] || 'Ungültiger Wert';
    }

    function formatPath(path, errors) {
        var parts = path.split('/').filter(Boolean);
        var lines = [];
        var blockIndex = null;
        var blockInfo = '';

        for (var i = 0; i < parts.length; i++) {
            var p = parts[i];
            var isNum = !isNaN(parseInt(p));

            if (p === 'blocks' && i === 0) {
                // Top-level blocks field — try to get block index from errors structure
                var val = errors[path];
                if (Array.isArray(val)) {
                    // Find non-null entries
                    var badBlocks = [];
                    val.forEach(function(item, idx) {
                        if (item !== null && item !== undefined) badBlocks.push('Block ' + (idx + 1));
                    });
                    if (badBlocks.length > 0) lines.push('📦 ' + badBlocks.join(', '));
                } else {
                    lines.push('📦 Inhaltsblöcke');
                }
            } else if (isNum && parts[i-1] === 'blocks') {
                blockIndex = parseInt(p);
                blockInfo = '📦 Block ' + (blockIndex + 1);
            } else if (isNum) {
                var parentKey = parts[i-1] || '';
                lines.push('  &rarr; ' + getLabel(parentKey) + ' #' + (parseInt(p) + 1));
            } else {
                var label = getLabel(p);
                if (i === parts.length - 1) {
                    // Last segment = actual field
                    lines.push('  &rarr; <strong>Feld: ' + label + '</strong>');
                }
            }
        }

        var result = '';
        if (blockInfo) result = blockInfo + '<br>' + lines.join('<br>');
        else result = lines.join('<br>');
        return result || path;
    }

    // Try to get block info from DOM/React
    function getBlockInfoFromDOM(blockIndex) {
        try {
            // Look for block entries in the admin UI
            var blockEls = document.querySelectorAll('[data-block-index], [class*="BlockList"] > *, [class*="block-list"] > *');
            if (blockEls[blockIndex]) {
                var titleEl = blockEls[blockIndex].querySelector('input[name*="title"], [class*="block-title"]');
                if (titleEl && titleEl.value) return ' ("' + titleEl.value.substring(0, 30) + '")';
            }
        } catch(e) {}
        return '';
    }

    function deepFindErrors(rootEl) {
        var fiberKey = Object.keys(rootEl || {}).find(function(k) {
            return k.startsWith('__reactFiber') || k.startsWith('__reactInternalInstance');
        });
        if (!fiberKey) return {};

        var allErrors = {};
        var visited = new WeakSet();

        function traverse(fiber, depth) {
            if (!fiber || depth > 500 || visited.has(fiber)) return;
            visited.add(fiber);

            var s = fiber.memoizedState;
            while (s) {
                var ms = s.memoizedState;
                if (ms && typeof ms === 'object') {
                    if (ms.errors && typeof ms.errors === 'object') Object.assign(allErrors, ms.errors);
                    if (ms._errors && typeof ms._errors === 'object') Object.assign(allErrors, ms._errors);
                }
                s = s.next;
            }

            var props = fiber.memoizedProps;
            if (props) {
                ['store', 'formStore'].forEach(function(key) {
                    var st = props[key];
                    if (st) {
                        if (st.errors && typeof st.errors === 'object') Object.assign(allErrors, st.errors);
                        if (st._errors && typeof st._errors === 'object') Object.assign(allErrors, st._errors);
                    }
                });
            }

            traverse(fiber.child, depth + 1);
            traverse(fiber.sibling, depth + 1);
        }

        traverse(rootEl[fiberKey], 0);
        return allErrors;
    }

    // Convert possibly-MobX observable array to real array
    function toArray(val) {
        if (Array.isArray(val)) return val;
        // Handle MobX observable arrays and array-like objects
        if (val && typeof val === 'object' && typeof val.length === 'number') {
            return Array.from(val);
        }
        return null;
    }

    function analyzeErrors(rawErrors) {
        // Flatten nested error structure into readable messages
        var messages = [];

        function dig(obj, pathParts) {
            if (!obj || typeof obj !== 'object') return;

            // Handle array-like (including MobX observable arrays)
            var arr = toArray(obj);
            if (arr && !obj.keyword) {
                arr.forEach(function(item, idx) {
                    if (item !== null && item !== undefined && item !== false) {
                        dig(item, pathParts.concat([String(idx)]));
                    }
                });
                return;
            }

            if (obj.keyword) {
                // This is a leaf error node
                var msg = getErrorMessage(obj);
                var field = pathParts[pathParts.length - 1];
                var blockIdx = null;
                var subBlockIdx = null;
                var subBlockKey = null;

                // Find block index
                for (var i = 0; i < pathParts.length; i++) {
                    if (pathParts[i] === 'blocks' && !isNaN(parseInt(pathParts[i+1]))) {
                        blockIdx = parseInt(pathParts[i+1]);
                    }
                    if (!isNaN(parseInt(pathParts[i])) && i > 0 && isNaN(parseInt(pathParts[i-1]))) {
                        // This is a nested block index (like features[0])
                        subBlockIdx = parseInt(pathParts[i]);
                        subBlockKey = pathParts[i-1];
                    }
                }

                var desc = '';
                if (blockIdx !== null) {
                    desc += '📦 <strong>Block ' + (blockIdx + 1) + '</strong>';
                }
                if (subBlockKey && subBlockIdx !== null) {
                    desc += ' › ' + getLabel(subBlockKey) + ' #' + (subBlockIdx + 1);
                }
                if (field && field !== String(subBlockIdx)) {
                    desc += ' › <em>' + getLabel(field) + '</em>';
                }
                desc += ': <span style="color:#e74c3c">' + msg + '</span>';
                messages.push(desc);
                return;
            }

            // Recurse into plain object
            Object.keys(obj).forEach(function(key) {
                if (key === 'keyword' || key === 'parameters') return; // skip AJV meta fields
                var val = obj[key];
                if (val === null || val === false || val === undefined) return;
                if (val === true) {
                    // Direct error
                    var field = key;
                    var blockIdx = null;
                    for (var i = 0; i < pathParts.length; i++) {
                        if (pathParts[i] === 'blocks' && !isNaN(parseInt(pathParts[i+1]))) {
                            blockIdx = parseInt(pathParts[i+1]);
                        }
                    }
                    var desc = '';
                    if (blockIdx !== null) desc += '📦 <strong>Block ' + (blockIdx + 1) + '</strong> › ';
                    desc += '<em>' + getLabel(field) + '</em>: <span style="color:#e74c3c">Pflichtfeld ist leer</span>';
                    messages.push(desc);
                } else if (toArray(val)) {
                    toArray(val).forEach(function(item, idx) {
                        if (item !== null && item !== undefined && item !== false) {
                            dig(item, pathParts.concat([key, String(idx)]));
                        }
                    });
                } else if (typeof val === 'object') {
                    dig(val, pathParts.concat([key]));
                }
            });
        }

        Object.keys(rawErrors).forEach(function(key) {
            var val = rawErrors[key];
            if (val === null || val === false || val === undefined) return;
            dig(val, [key]);
        });

        // Deduplicate
        return messages.filter(function(m, i) { return messages.indexOf(m) === i; });
    }

    function showOverlay(rawErrors, messages) {
        if (!messages) messages = analyzeErrors(rawErrors);
        if (messages.length === 0) return;

        var existing = document.getElementById('sulu-val-overlay');
        if (existing) existing.remove();

        var overlay = document.createElement('div');
        overlay.id = 'sulu-val-overlay';
        overlay.style.cssText = [
            'position:fixed', 'top:60px', 'right:20px', 'z-index:99999',
            'background:#fff', 'border-left:4px solid #e74c3c', 'border-radius:6px',
            'padding:16px 20px', 'max-width:480px', 'width:440px',
            'box-shadow:0 6px 30px rgba(0,0,0,.18)', 'font-family:sans-serif',
            'font-size:13px', 'max-height:75vh', 'overflow-y:auto',
            'line-height:1.6'
        ].join(';');

        overlay.innerHTML =
            '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;border-bottom:1px solid #fee2e2;padding-bottom:10px">' +
            '<div><strong style="color:#e74c3c;font-size:15px">⚠ Formular ungültig</strong>' +
            '<div style="font-size:11px;color:#999;margin-top:2px">' + messages.length + ' Problem' + (messages.length !== 1 ? 'e' : '') + ' gefunden</div></div>' +
            '<button onclick="document.getElementById(\'sulu-val-overlay\').remove()" ' +
            'style="border:none;background:#fee2e2;cursor:pointer;font-size:16px;color:#e74c3c;' +
            'width:28px;height:28px;border-radius:50%;display:flex;align-items:center;justify-content:center;' +
            'flex-shrink:0;margin-left:10px">×</button>' +
            '</div>' +
            '<div style="color:#374151">' +
            messages.map(function(m, i) {
                return '<div style="padding:8px 10px;margin-bottom:6px;background:#fef2f2;border-radius:4px;font-size:12px">' +
                    '<span style="color:#6b7280;font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:.05em">Problem ' + (i+1) + '</span><br>' +
                    m + '</div>';
            }).join('') +
            '</div>' +
            '<div style="margin-top:10px;padding-top:8px;border-top:1px solid #f3f4f6;font-size:11px;color:#9ca3af">' +
            '💡 Scrolle zum betreffenden Block und fülle das rot markierte Feld aus.' +
            '</div>';

        document.body.appendChild(overlay);
        setTimeout(function() { if (overlay.parentNode) overlay.remove(); }, 90000);
    }

    // Scan ALL elements with React fibers (reliable but slower)
    function findErrorsAnywhere() {
        var allErrors = {};
        var all = document.querySelectorAll('*');
        var tried = 0;
        for (var i = 0; i < all.length && tried < 30; i++) {
            var keys = Object.keys(all[i]);
            if (keys.some(function(k) { return k.startsWith('__reactFiber') || k.startsWith('__reactInternalInstance'); })) {
                tried++;
                var found = deepFindErrors(all[i]);
                if (Object.keys(found).length > 0) Object.assign(allErrors, found);
            }
        }
        return allErrors;
    }

    function scanAndShow() {
        var allErrors = findErrorsAnywhere();
        var hasRealErrors = Object.keys(allErrors).some(function(k) {
            var v = allErrors[k];
            return v !== null && v !== false && v !== undefined;
        });
        if (!hasRealErrors) return false;

        var messages = analyzeErrors(allErrors);

        // Fallback: if analyzeErrors found nothing, show raw dump for debugging
        if (messages.length === 0) {
            var raw = JSON.stringify(allErrors).substring(0, 500);
            messages = ['<strong>Unbekannte Validierungsfehler</strong><br><code style="font-size:10px;word-break:break-all">' + raw + '</code>'];
        }

        showOverlay(allErrors, messages);
        return true;
    }

    // Click listener on Speichern button
    document.addEventListener('click', function(e) {
        var btn = e.target && e.target.closest && e.target.closest('button');
        if (!btn) return;
        var text = (btn.textContent || '').trim();
        if (!['Speichern', 'Veröffentlichen', 'Save', 'Publish'].some(function(t) { return text === t; })) return;
        [400, 1000, 2000].forEach(function(delay) {
            setTimeout(function() { scanAndShow(); }, delay);
        });
    }, true);

    // MutationObserver: detect snackbar with "ungültige"
    var observer = new MutationObserver(function() {
        document.querySelectorAll('[class*="snackbar--"]').forEach(function(el) {
            if (!el.textContent.includes('ungültige') && !el.textContent.includes('invalid')) return;
            if (el.dataset.suluHandled) return;
            el.dataset.suluHandled = '1';
            setTimeout(function() { scanAndShow(); }, 500);
        });
    });

    function start() { observer.observe(document.body, { childList:true, subtree:true, attributes:true, attributeFilter:['class'] }); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
